import { TriangleAlert, UserCheck } from "lucide-react";
import {
  doctorHasNotOpenedStartedMeeting,
  meetingCalendarStatus,
  type ClinicianMeeting,
} from "@care-by-ella/contracts";

// TES-1233 — two of Emelie's protections against a missed meeting, in one
// place so "Nästa möte", the calendar block and its side panel say them the
// same way:
//   "Tydlig status när patienten har anslutit"
//   "Varning om mötet har börjat men läkaren inte har öppnat det"
//
// "Anslutit" is read from the patient pressing "Anslut" in the app (her Daily
// token); the video connection itself is not reported to us.
export function MeetingSignals({
  meeting,
  now,
}: {
  meeting: ClinicianMeeting;
  now: number;
}) {
  const status = meetingCalendarStatus(meeting, now);
  const live = status === "booked" || status === "ongoing";
  const patientIn = live && Boolean(meeting.patientJoinedAt);
  const warn = doctorHasNotOpenedStartedMeeting(meeting, now);
  if (!patientIn && !warn) return null;
  return (
    <div className="flex flex-col gap-xs">
      {patientIn ? (
        <p className="inline-flex items-center gap-xs text-sm font-medium text-status-complete-ink">
          <UserCheck aria-hidden className="h-4 w-4 shrink-0" />
          Patienten har anslutit
        </p>
      ) : null}
      {warn ? (
        <p
          role="alert"
          className="inline-flex items-center gap-xs rounded-md bg-status-risk-fill px-sm py-xs text-sm font-medium text-status-risk-ink"
        >
          <TriangleAlert aria-hidden className="h-4 w-4 shrink-0" />
          Mötet har börjat men läkaren har inte öppnat det
        </p>
      ) : null}
    </div>
  );
}
